import React from 'react';
import axios from 'axios';

import { useTimeModal } from './TimeModal/TimeModalContext';

import styles from '../Styles/DynamicModal.module.css';

const DeleteUserConfirmationModal = ({ closeModal, userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();
    const [status, setStatus] = React.useState('');

    React.useEffect(() => {
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    const deleteUser = () => {
        axios.delete('/api/delete-user', { data: { userId } })
        .then(() => {
            openTimeModal('Пользователь удален', 'success');
            closeModal();
            onSuccess(true);
        })
        .catch((err) => {
            openTimeModal('Ошибка удаления пользователя', 'error');
        });
    };


    return (
        <div className={styles.liningOver} onClick={() => {closeModal()}}>
        <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
            <div className={styles.header}>
            <div style={{display: 'flex', alignItems: 'center'}}>
                <h1>Подтверждение действия</h1>
            </div>
            <svg onClick={() => {closeModal()}} viewBox="0 0 24 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
            </svg>
            </div>
            <div className={styles.main}>
            <a style={{marginBottom: '20px'}}>Вы уверены, что хотите удалить заявку на доступ к админ-панели?</a>
            {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
            <button type='button' className='button maxWidth black' onClick={deleteUser}>Подтвердить удаление</button>
            </div>
        </form>
        </div>
    );
};

export default DeleteUserConfirmationModal;
